import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Box } from '@material-ui/core';

import DefaultPageWraper from '../../../containers/PageStructure/DefaultPageWrapper/DefaultPageWrapperContainer';
import { numberInRangeFrom0To100 } from '../../../settings/constants/regex';
import globals from '../../../globals/communityGlobals';
import { getAutoAllocateWeightings, updateAutoAllocateWeightings } from '../../../actions/areas/admin';

const locale = globals.getAreas(['autoAllocateWeightings', 'error']);

export default function AutoAllocateWeightings() {
  const dispatch = useDispatch();
  const [weightings, setWeightings] = useState([]);
  const [sumErrorMessage, setSumErrorMessage] = useState('');

  useEffect(() => {
    dispatch(getAutoAllocateWeightings()).then(({ response }) => {
      setWeightings(response.data.autoAllocateWeightings);
    });
  }, []);

  function updateWeightingValue(id, event) {
    const updatedList = [...weightings];
    updatedList.forEach(item => {
      if (item.id === id) item.weightingValue = event.target.value;
    });
    setWeightings(updatedList);
  }

  const handleSave = () => {
    const sum = weightings.reduce((acc, current) => acc + parseInt(current.weightingValue, 10), 0);
    if (sum !== 100) {
      setSumErrorMessage(locale.getMsg('weightingsSumError'));
    } else {
      dispatch(updateAutoAllocateWeightings(weightings));
      setSumErrorMessage('');
    }
  };

  const isValid = value => {
    return !value.match(numberInRangeFrom0To100);
  };

  const renderWeightings = () => {
    return weightings.map(w => {
      return (
        <Box className="weightings" display="flex" px={2} py={1}>
          <div key={w.id} className="row allocateWeightings">
            <div className="col-c6">{w.weightingName}</div>
            <div className="col-c6">
              <TextField
                key={w.id}
                type="number"
                name="weightingValue"
                value={w.weightingValue}
                onChange={e => updateWeightingValue(w.id, e)}
                error={isValid(w.weightingValue)}
                helperText={isValid(w.weightingValue) ? locale.getMsg('validationNumberRange', ['0-100']) : ' '}
              />
            </div>
          </div>
        </Box>
      );
    });
  };

  return (
    <DefaultPageWraper pageTitle="Auto Allocate Weightings">
      <Box px={2} py={1}>
        {/* <RaisedButton primary label={locale.getMsg('saveButton')} onClick={handleSave} /> */}

        <span style={{ color: 'red' }}>{sumErrorMessage}</span>
        <div className="row" style={{ marginBottom: '22px', marginTop: '22px', fontWeight: 'bold' }}>
          <div className="col-c6">{locale.getMsg('weightingName')}</div>
          <div className="col-c6">{locale.getMsg('weightingValue')}</div>
        </div>
        {renderWeightings()}
        <Button variant="contained" color="primary" onClick={handleSave}>
          {locale.getMsg('saveButton')}
        </Button>
      </Box>
    </DefaultPageWraper>
  );
}
